import { render, staticRenderFns } from "./backgroundStroy.vue?vue&type=template&id=c98fbd76&scoped=true"
import script from "./backgroundStroy.vue?vue&type=script&lang=js"
export * from "./backgroundStroy.vue?vue&type=script&lang=js"
import style0 from "./backgroundStroy.vue?vue&type=style&index=0&id=c98fbd76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98fbd76",
  null
  
)

export default component.exports